__turbopack_context__.v({
  "contactContainer": "footer-module__KL6qjG__contactContainer",
  "contactLabel": "footer-module__KL6qjG__contactLabel",
  "contactLink": "footer-module__KL6qjG__contactLink",
  "contactLinks": "footer-module__KL6qjG__contactLinks",
  "container": "footer-module__KL6qjG__container",
  "copyright": "footer-module__KL6qjG__copyright",
  "emailInput": "footer-module__KL6qjG__emailInput",
  "emailInputError": "footer-module__KL6qjG__emailInputError",
  "emailInputWrapper": "footer-module__KL6qjG__emailInputWrapper",
  "errorMessage": "footer-module__KL6qjG__errorMessage",
  "footer": "footer-module__KL6qjG__footer",
  "legal": "footer-module__KL6qjG__legal",
  "legalLink": "footer-module__KL6qjG__legalLink",
  "legalText": "footer-module__KL6qjG__legalText",
  "linkCard": "footer-module__KL6qjG__linkCard",
  "linkCardDescription": "footer-module__KL6qjG__linkCardDescription",
  "linkCardTitle": "footer-module__KL6qjG__linkCardTitle",
  "linksGrid": "footer-module__KL6qjG__linksGrid",
  "logo": "footer-module__KL6qjG__logo",
  "nav": "footer-module__KL6qjG__nav",
  "navContainer": "footer-module__KL6qjG__navContainer",
  "navLink": "footer-module__KL6qjG__navLink",
  "navLinks": "footer-module__KL6qjG__navLinks",
  "navTitle": "footer-module__KL6qjG__navTitle",
  "newsletter": "footer-module__KL6qjG__newsletter",
  "newsletterContent": "footer-module__KL6qjG__newsletterContent",
  "newsletterHeading": "footer-module__KL6qjG__newsletterHeading",
  "newsletterSubheading": "footer-module__KL6qjG__newsletterSubheading",
  "newsletterText": "footer-module__KL6qjG__newsletterText",
  "socialContainer": "footer-module__KL6qjG__socialContainer",
  "socialLink": "footer-module__KL6qjG__socialLink",
  "socialLinks": "footer-module__KL6qjG__socialLinks",
  "subscribeButton": "footer-module__KL6qjG__subscribeButton",
  "subscribeForm": "footer-module__KL6qjG__subscribeForm",
  "successMessage": "footer-module__KL6qjG__successMessage",
});
